/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2022-11-11 14:56:13
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2023-12-21 14:45:03
 * @FilePath     : /ticket-plat-frontend/src/config/online.ts
 */
// 智能助手
import {ENV_CONFIG} from './index';
const ZNZS_HOST = 'https://console.bce.baidu.com/znzs';
const SUPPORT_HOST = 'https://console.bce.baidu.com/support';

const config: ENV_CONFIG = {
    MATCHER: new RegExp(/^(ticket|console)\.bce\./g),
    IS_XS: false,
    MOBILE_TICKET_HOST: 'ctssmartprogram.baidu.com',
    // 自助服务
    TOOLS_HOST: 'https://console.bce.baidu.com/tools',
    TOOL_HOST: 'https://console.bce.baidu.com/tools/?header=hidden&u=ticket-home#/index',
    CONSOLE_HOST: 'https://console.bce.baidu.com',
    CLOUD_HOST: 'https://cloud.baidu.com',
    CONSOLE_LOGIN_HOST: 'https://login.bce.baidu.com/',
    // 云音
    VOC_HOST: 'https://console.bce.baidu.com/voc/',
    // 智能助手
    ZNZS_HOST,
    // 智能助手h5
    ZNZS_H5_HOST: `${ZNZS_HOST}/znzs-app`,
    // 浮窗打开小助手拦截地址
    ZNZS_H5_WINDOW_URL: `${ZNZS_HOST}/?enable_help_center=true&help_center_type=znzs&platform=ticket`,
    // 埋点 appTag
    APP_TAG: 'ticket-plat-online',
    ACA_HOST: 'https://console.bce.baidu.com/aca',
    // 服务与支持
    SUPPORT_HOST,
};

export default config;
